module.exports = __webpack_public_path__ + "images/emoji/globe_with_meridians.5d50dcc50cbdc687972e.png";